import { Text } from "@/elements"

export const SkillPill = ({ skill }: { skill?: string }) => {
  return (
    <div className="flex h-[31px] w-min items-center justify-center rounded-full border border-bg-3 px-[11px]">
      <Text variant="label" className="whitespace-nowrap">
        {skill}
      </Text>
    </div>
  )
}
